if (!customElements.get('truegear-games')) {
  customElements.define('truegear-games', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const cards = [...this.querySelectorAll('[data-game-card]')];
      const status = this.querySelector('[data-game-status]');
      const more = this.querySelector('[data-game-more]');
      let limit = 12;
      const update = () => {
        const visible = new Set(cards.slice(0, limit));
        cards.forEach(card => { card.hidden = !visible.has(card); });
        status.textContent = `${cards.length}タイトル中 ${visible.size}件を表示`;
        more.hidden = cards.length <= limit;
      };
      more.addEventListener('click', () => {
        const previous = cards.filter(card => !card.hidden);
        limit += 24;
        update();
        const next = cards.find(card => !card.hidden && !previous.includes(card));
        if (next) next.querySelector('.tg-games__name').focus({ preventScroll: true });
      });
      update();
    }
  });
}
